
import ConfigService from "./ConfigService";
import HttpService from "./HttpService";
import AuthService from "./AuthService";

import { DateTime } from "luxon";

export default class CoreService {
  constructor(coreDomain) {
    this.configService = new ConfigService();
    this.domain = coreDomain || this.configService.getCoreServiceHost();
    this.authService = new AuthService();
  }

  async fetchVersion(token) {
    const path = "/api/admin/version";
    var response = await HttpService.get(this.domain, path, token);
    return response;
  }

  async pingCore(token) {
    const path = "/api/admin/ping";
    var response = await HttpService.get(this.domain, path, token);
    return response;
  }



  async fetchLog(eventType, hoursBeforeNow, token) {
    var iso8601StartDate = DateTime.now().setZone('America/Los_Angeles').minus({ hours: hoursBeforeNow }).toISO();
    const path = "/api/telemetry/gcid/cg/pollingtelemetryevent?maxCount=1000&startDate=" + iso8601StartDate + "&eventtype=" + eventType;
    var response = await HttpService.get(this.domain, path, token);
    return response;
  }

  async fetchNabcFilter(filterType, token)
  {
    const path = "/api/nabc/gcid/cg/valuereplacementfilter/filtertype/" + filterType;
    var response = await HttpService.get(this.domain, path, token);
    return response;
  }

  async fetchNABCShipmentFilter(token) {
    const path = "/api/nabc/gcid/cg/valuereplacementfilter/filtertype/NabcShipmentFilter";
    var response = await HttpService.get(this.domain, path, token);
    return response;
  }

  async fetchNABCInventoryFilter(token) {
    const path = "/api/nabc/gcid/cg/valuereplacementfilter/filtertype/NabcOpenInventoryFilter";
    var response = await HttpService.get(this.domain, path, token);
    return response;
  }

  async postNABCUpdateValueReplacementFilter(token, data){
    const path = "/api/nabc/gcid/cg/valuereplacementfilterupdate";
    var response = await HttpService.postJson(this.domain, path, token, data);
    return response;
  }
  
}